var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _handleProductSelect;
import { ThemeEvents } from "@theme/events";
import { morph } from "@theme/morph";
import { Component } from "@theme/component";
import { StandardEvents, ProductSelectEvent } from "@shopify/events";
class ProductInventory extends Component {
  constructor() {
    super(...arguments);
    this.selectionGeneration = 0;
    this.selectionDetached = false;
    this.selectionTarget = null;
    __privateAdd(this, _handleProductSelect, (event) => {
      var _a;
      if (!(event.target instanceof Element) || event.target.closest("product-card")) return;
      if (!event.promise || typeof event.promise.then !== "function" || this.selectionDetached) return;
      if (((_a = event.product) == null ? void 0 : _a.id) && this.dataset.productId && String(event.product.id) !== String(this.dataset.productId)) return;
      const generation = ++this.selectionGeneration;
      return event.promise.then(({ detail }) => {
        if (this.selectionDetached || generation !== this.selectionGeneration) return;
        if (!(detail == null ? void 0 : detail.html)) return;
        const { html, newProduct } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }
        const newInventory = html.querySelector("product-inventory");
        if (!newInventory) return;
        morph(this, newInventory, { childrenOnly: true });
      }).catch((error) => {
        if ((error == null ? void 0 : error.name) !== "AbortError") console.warn("[product-inventory] Event promise rejected:", error);
      });
    });
  }
  connectedCallback() {
    var _a;
    super.connectedCallback();
    this.selectionDetached = false;
    const closestSection = this.closest(".shopify-section, dialog");
    (_a = this.selectionTarget) == null ? void 0 : _a.removeEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
    this.selectionTarget = closestSection;
    closestSection == null ? void 0 : closestSection.addEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
  }
  disconnectedCallback() {
    var _a;
    super.disconnectedCallback();
    this.selectionDetached = true;
    ++this.selectionGeneration;
    (_a = this.selectionTarget) == null ? void 0 : _a.removeEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
    this.selectionTarget = null;
  }
}
_handleProductSelect = /* @__PURE__ */ new WeakMap();
if (!customElements.get("product-inventory")) {
  customElements.define("product-inventory", ProductInventory);
}
